import { StatsDataServiceInterface } from './service.interface';
import { StatsDataFactory } from '../../module/stats/data.factory';

const statsDataService = StatsDataFactory();

export function StatsDataService(): StatsDataServiceInterface {
  return statsDataService;
}
